export enum BidHistoryOperation {
    Created = 'Created',
    Updated = 'Updated',
    Deleted = 'Deleted',
}
